import styled from "@emotion/styled";
import { Button, TextField } from "@mui/material";

export const DetailsPageContainer = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.tertiary,
	overflowX: "auto"
}));

export const DetailsPageContent = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	margin: "16px 24px",
	padding: "16px 32px",
	display: "flex",
	gap: "12px",
	minHeight: "492px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		padding: "16px"
	}
}));

export const ItemDetails = styled.div(({ theme }) => ({
	color: theme.project.colors.fontColors.main
}));

export const BackorderBannerWrapper = styled.div({
	margin: "1em 0"
});

export const AddToCartContent = styled.div({
	display: "flex",
	gap: "20px",
	alignItems: "center",
	height: "42px"
});

export const AddToCartQuantityField = styled(TextField)(() => ({}));

export const AddToCartButton = styled(Button)(() => ({
	width: "167px"
}));
